/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <div class="cart-recap__segments">
    <div
      :class="'single-recap-item cart-recap__'+segment.code"
      v-for="segment in totalSegments"
      :key="segment.code">
        <div class="line">
          <div class="label">{{ $t(segment.title) }}</div>
          <div class="value"><span>{{ segment.value | price($store) }}</span></div>
        </div>
        <div class="discount-wrapp">
          <div v-for="discount in segment.discount" :key="discount.promotion_id" class="discount-line line">
            <div class="label">{{ $t(discount.item_text) }}</div>
            <div class="value"><span>{{ discount.price | price($store) }}</span></div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SummaryPrice',
  computed: {
    totalSegments () {
      return this.$store.getters['cart/totalSegments']
    }
  }
}
</script>
